import React, { CSSProperties } from 'react';
import { XIcon } from '@heroicons/react/outline';

type TextInputProps = {
  name: string;
  value: string;
  onChange: React.ChangeEventHandler<HTMLInputElement>;
  label?: string;
  placeholder?: string;
  error?: string;
  extraClass?: string;
  infoText?: string;
  type?: string;
  disabled?: boolean;
  autoFocus?: boolean;
  readOnly?: boolean;
  style?: CSSProperties;
  inlineLabel?: string;
  labelClass?: string;
  onKeyUp?: React.KeyboardEventHandler<HTMLInputElement>;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  inputClassName?: string;
  tabIndex?: number;
  reset?: React.MouseEventHandler<SVGSVGElement>;
};

const TextInput = ({
  name,
  label,
  onChange,
  placeholder,
  value,
  error,
  extraClass,
  type,
  disabled,
  autoFocus,
  readOnly,
  style,
  inlineLabel,
  labelClass,
  onKeyUp,
  onKeyDown,
  inputClassName,
  tabIndex,
  reset
}: TextInputProps) => {
  let wrapperClass = 'form-group';
  if (error && error.length > 0) {
    wrapperClass += ' has-error';
  }
  if (extraClass) {
    wrapperClass += ' ' + extraClass;
  }

  return (
    <div className={wrapperClass}>
      {label && <label htmlFor={name}>{label}</label>}
      <div className="field relative">
        {inlineLabel && <span className={'form-group ' + labelClass}>{inlineLabel} &nbsp;</span>}
        <input
          type={type || 'text'}
          name={name}
          disabled={disabled || false}
          className={'form-control ' + inputClassName}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          autoFocus={autoFocus}
          style={style}
          onKeyUp={onKeyUp}
          onKeyDown={onKeyDown}
          tabIndex={tabIndex}
          readOnly={readOnly}
        />
        {reset && (
          <XIcon
            onClick={reset}
            className={`text-gray-500 hover:text-gray-700 absolute top-2 right-1 w-6 h-6 transition duration-75
            ${value.length >= 1 ? 'opacity-100 cursor-pointer' : 'opacity-0 pointer-events-none'}`}
          />
        )}
        {error && <span className="help-block">{error}</span>}
      </div>
    </div>
  );
};

export default TextInput;
